<div class="alert alert-danger" role="alert" *ngIf="has_maxed_out">
    TIP - You have bundles which have maxed out their usage limits. Click <a routerLink="/settings/services" [queryParams]="{ status: 'Maxed Out' }" class="servicesButton">HERE</a> to renew the bundle.
</div>

<div class="alert alert-danger" role="alert" *ngIf="has_expired">
    TIP - You currently have expired services. You can check them at the <a routerLink="/settings/services" [queryParams]="{ status: 'Expired' }">SERVICES</a> page, or you can make sure you have enough credit for these to autorenew by <a routerLink="/topup">Topping Up</a>
</div>